export default {
  GRP_ARR: []
}
